import { FC } from 'react'
import * as styles from 'components/features/pfm/Popup/PopupCloseButton.css'
import Button from 'components/features/pfm/Button/Button'

type Props = {
  onClick: () => void
}

const PopupCloseButton: FC<Props> = ({ onClick }) => (
  <div className={ styles.buttonWrapper }>
    <Button
      style='outlined'
      size='responsive'
      onClick={ onClick }
    >
      Close
    </Button>
  </div>
)

export default PopupCloseButton
